import * as d3 from 'd3';
import data from '../../../../data/data.json';

let yearsData = data['years'],
  yearsNames = yearsData.map(y => y.year),
  years = ['---'].concat(yearsNames),
  yColumn = years[0];

// dropdown menu handling
let onYColumnClicked = (column, windowWidth) => {
  yColumn = column;
  goToSection(column, windowWidth);
};

let dropdownMenu = (selection, props) => {
  let { options, onOptionClicked, selectedOption } = props;

  let select = selection.selectAll('select').data([null]);
  select = select
    .enter()
    .append('select')
    .merge(select)
    .attr('class', 'years-select-menu')
    .on('change', function() {
      onOptionClicked(this.value);
    });

  let option = select.selectAll('option').data(options);
  option
    .enter()
    .append('option')
    .merge(option)
    .attr('value', d => d)
    .property('selected', d => d === selectedOption) // why is this here?
    .text(d => d);
};

function goToSection(column, windowWidth) {
  if (column != '---') {
    let element = document.querySelector(`[year="${column}"]`),
      y =
        element.getBoundingClientRect().top +
        window.pageYOffset -
        (windowWidth < 544 ? 115 : 75);

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

d3.select('#menu-years').call(dropdownMenu, {
  options: years,
  onOptionClicked: onYColumnClicked,
  selectedOption: yColumn,
});

function resize() {
  d3.select('.years-select-menu').on('change', function() {
    onYColumnClicked(this.value, window.innerWidth);
  });
}

resize();
window.addEventListener('resize', resize);
